import { getDeployment, registerDeployment, type Deployment } from '@syntra/abi';

/**
 * One chain per build (wagmi reads through its first chain when no wallet is connected, so a multi-chain build
 * would silently read the wrong one).
 */
export const CHAIN_ID = Number(import.meta.env.VITE_CHAIN_ID ?? 31337);
export const RPC_URL: string = import.meta.env.VITE_RPC_URL ?? 'http://127.0.0.1:28545';
export const WALLETCONNECT_PROJECT_ID: string | undefined = import.meta.env.VITE_WC_PROJECT_ID || undefined;
export const INDEXER_URL: string | undefined = import.meta.env.VITE_INDEXER_URL || undefined;
/** Testnet only: services/faucet, which sends test BNB for gas and test USDT without the tester paying gas. */
export const FAUCET_URL: string | undefined = import.meta.env.VITE_FAUCET_URL || undefined;
/** The project's community links; a network left unset shows its button greyed out as "coming soon". */
export const SOCIAL = {
  telegram: import.meta.env.VITE_TELEGRAM_URL || undefined,
  x: import.meta.env.VITE_X_URL || undefined,
} as { telegram?: string; x?: string };
export const EXPLORER: string =
  CHAIN_ID === 56 ? 'https://bscscan.com' : CHAIN_ID === 97 ? 'https://testnet.bscscan.com' : '';

function loadDeployment(): Deployment {
  if (CHAIN_ID === 31337) return getDeployment(31337);
  const raw = import.meta.env.VITE_DEPLOYMENT_JSON;
  if (!raw) throw new Error(`VITE_DEPLOYMENT_JSON is required for chain ${CHAIN_ID}`);
  return registerDeployment(JSON.parse(raw), (import.meta.env.VITE_USDT as `0x${string}` | undefined) || undefined);
}

export const DEPLOYMENT = loadDeployment();
export const IS_LOCAL = CHAIN_ID === 31337;
